
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/masterclass",
      function () {
        return require("private-next-pages/masterclass/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/masterclass"])
      });
    }
  